/**
 * TaxiEditorToggle — enter/exit the taxi waypoint editor. On enter the page
 * engages top-down and mounts the editable overlay + panel.
 */
import { Waypoints } from 'lucide-react'
import { ToolbarButton } from './ToolbarButton'

interface Props {
  active: boolean
  onToggle: () => void
  fullWidth?: boolean
}

export function TaxiEditorToggle({ active, onToggle, fullWidth }: Props) {
  return (
    <ToolbarButton
      icon={<Waypoints className="h-4 w-4" />}
      label="Taxiways"
      accent="sky"
      active={active}
      fullWidth={fullWidth}
      onClick={onToggle}
      title="Edit taxi waypoints (place/drag nodes, connect edges, close segments)"
    />
  )
}
